import React from 'react';
import Parent from 'components/Parent';

export const App = () => {
  return <Parent />;
};
